import React from "react";
import { Box, Typography, Container, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import NewlyLaunchedCard from "../../cards/newlyAddedCards";

import threeSlotBg from "../../../../../static/Images/newlyAdded/3_slot_game.png";
import fiveSlotBg from "../../../../../static/Images/newlyAdded/5_slot_game.png";
import bgImage from "../../../../../static/Images/newlyAdded/newlyAddedGames_bg.png";

const GAMES = [
  {
    id: "3-slotbet",
    type: "3-slot",
    title: "3-SlotBET",
    category: "SLOTS",
    accent: "red",
    image: threeSlotBg,
  },
  {
    id: "5-slotbet",
    type: "5-slot",
    title: "5-SlotBET",
    category: "SLOTS",
    accent: "blue",
    image: fiveSlotBg,
  },
];

const NewlyLaunched = () => {
  const theme = useTheme();

  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        paddingTop: "20px",
        paddingBottom: "20px",
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        bgcolor: "#f7f9fc",
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          width: "100%",
          maxWidth: "1400px",
          mx: "auto",
          px: theme.custom?.["home-section-left-padding"] || "40px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack
          direction="column"
          alignItems="flex-start"
          justifyContent="flex-start"
          sx={{
            width: "100%",
            mb:
              theme.typography.homeSection?.headerBottomMargin || {
                xs: 4,
                md: 5,
              },
          }}
        >
          <Box sx={theme.typography.homeSection?.headerContainer || {}}>
            <Typography
              component="p"
              sx={{
                ...(theme.typography.homeSection?.eyebrow || {}),
                color: "primary.main",
                "&::before": {
                  ...(theme.typography.homeSection?.eyebrow?.[
                    "&::before"
                  ] || {}),
                  background: theme.palette.primary.main,
                },
              }}
            >
              NEW GAMES
            </Typography>

            <Typography
              component="h2"
              sx={{
                ...(theme.typography.homeSection?.heading || {}),
                color:
                  theme.custom?.colors?.home?.navyDark || "#0d1b36",
              }}
            >
              Newly Launched
            </Typography>

          </Box>
        </Stack>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "repeat(2, minmax(0, 1fr))",
            },
            gap: "24px",
          }}
        >
          {GAMES.map((game) => (
            <NewlyLaunchedCard key={game.id} game={game} />
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default NewlyLaunched;